import React from 'react'
import { Modal, Button, Stack, Text } from '@mantine/core'
import { useSelector } from 'react-redux'

const SwitchOrgModal = ({ show, onClose, onSelect }) => {
	const currentOrgSlug = useSelector((state) => state.user.currentOrg?.orgSlug)
	const orgs = useSelector((state) => state.user.orgMemberships || [])
	const activeOrgs = orgs.filter((org) => org.isActive !== false)

	return (
		<Modal
			opened={show}
			onClose={onClose}
			title='Switch Organization'
			centered
			overlayProps={{ opacity: 0.4, blur: 2 }}
			size='sm'
		>
			<Stack>
				{activeOrgs.length === 0 && (
					<Text c='dimmed'>No active organizations available.</Text>
				)}
				{activeOrgs.map((org) => (
					<Button
						key={org.orgId}
						variant={org.orgSlug === currentOrgSlug ? 'filled' : 'light'}
						color={org.orgSlug === currentOrgSlug ? 'gray' : 'blue'}
						disabled={org.orgSlug === currentOrgSlug}
						fullWidth
						onClick={() => onSelect(org)}
					>
						{org.orgName}
					</Button>
				))}
			</Stack>
		</Modal>
	)
}

export default SwitchOrgModal
